import {Component, Input, NgModule} from '@angular/core';

@Component({
  selector: 'sd-toolbar',
  exportAs: 'sdToolbar',
  standalone: true,
  template: `<ng-content></ng-content>`,
  host: {class: 'sd-toolbar sd-toolbar flex items-center'},
})
export class SdToolbar {
  @Input() color: string | undefined;
}

@NgModule({
  imports: [SdToolbar],
  exports: [SdToolbar],
})
export class SdToolbarModule {}
